// Slice de suscripción de planes
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pagos: [], // Lista de pagos de planes realizados
  planActual: null, // Información del plan actual de la empresa
  klapOrderId: null, // ID de orden de KLAP para procesar pago
  failureSuscripcion: false,
  errorSuscripcion: null,
  isLoadingSuscripcion: false,
};

const suscripcionSlice = createSlice({
  name: "suscripcion",
  initialState,
  reducers: {
    setPagos: (state, action) => {
      state.pagos = action.payload;
      state.failureSuscripcion = false;
      state.isLoadingSuscripcion = false;
    },
    setPlanActual: (state, action) => {
      state.planActual = action.payload;
      state.failureSuscripcion = false;
      state.isLoadingSuscripcion = false;
    },
    setKlapOrderId: (state, action) => {
      state.klapOrderId = action.payload;
      state.failureSuscripcion = false;
      state.isLoadingSuscripcion = false;
    },
    suscripcionSuccess: (state, action) => {
      state.failureSuscripcion = false;
      state.isLoadingSuscripcion = false;
    },
    suscripcionFailure: (state, action) => {
      state.failureSuscripcion = true;
      state.isLoadingSuscripcion = false;
      state.errorSuscripcion = action.payload; // mensaje de error
    },
    suscripcionReset: (state) => {
      state.pagos = [];
      state.planActual = null;
      state.klapOrderId = null;
      state.failureSuscripcion = false;
      state.errorSuscripcion = null;
      state.isLoadingSuscripcion = false;
    },
    setLoadingSuscripcion: (state, action) => {
      state.isLoadingSuscripcion = action.payload;
    },
    resetKlapOrderId: (state) => {
      state.klapOrderId = null;
    },
  },
});

export const {
  setPagos,
  setPlanActual,
  setKlapOrderId,
  suscripcionSuccess,
  suscripcionFailure,
  suscripcionReset,
  setLoadingSuscripcion,
  resetKlapOrderId,
} = suscripcionSlice.actions;

export default suscripcionSlice.reducer;
